import type { MapToken } from 'ant-design-vue/es/theme/interface'
import type { ResolvedThemes } from './stores/settings'

export type ThemeColors = {
  [Key in ResolvedThemes]: Partial<MapToken>
}

export const colors: ThemeColors = {
  Dark: {
    colorPrimary: '#00b96b',
    colorText: '#ebebebb4',
  },
  Light: {
    colorPrimary: '#00b96b',
    colorText: '#42464b',
  },
} as const
